
import { Component, Vue, Prop } from "vue-property-decorator";
import Axios from "axios";
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";

@Component
export default class DeclinedReasonComponent extends Vue {
  @Prop() public data;

  public declinedReason = null;
  public disableSubmitbutton = false;

  public async validateAndSubmit() {
    if (this.data) {
      let valid = await this.$validator.validateAll();
      if (valid) {
        this.data["declinedReason"] = this.declinedReason;
        this.disableSubmitbutton = true;
        this.$showLoader(true);
        let response = await Axios.post(
          API_STORE.PORTAL + "updatePaymentRequest",
          this.data,
          {
            headers: getAPIAuthorizedHeader(),
          }
        );
        this.disableSubmitbutton = false;
        this.$showLoader(false);
        if (response) {
            this.$snotify.success(response.data.message);
            this.$emit("updateDeclinedReason", true);
        }
      }
    }
  }

  resetForm() {
    this.$emit("cancel", true);
  }
}
